import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { RecaptchaTermsAndPolicy, useInvisibleRecaptcha } from '@atlassian/google-recaptcha';
import { useEnvironment } from '@atlassian/jira-tenant-context-controller';
import { getRecaptchaSiteKey } from '../../../services/invite/utils';

export const useRecaptcha = () => {
	const environment = useEnvironment();
	return useInvisibleRecaptcha({
		siteKey: getRecaptchaSiteKey(environment),
		displayBadge: false,
		analyticsChannel: 'jira',
		analyticsSource: 'inviteOnLinkInsert',
	});
};

export const RecaptchaTerms = () => (
	<RecaptchaContainer>
		<RecaptchaTermsAndPolicy />
	</RecaptchaContainer>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RecaptchaContainer = styled.div({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '10px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest', colors.N300),
	marginTop: token('space.075', '6px'),
	marginBottom: token('space.050', '4px'),
});
